export class StatusRamo{
    id:string;
    nome:string;
}


export enum StatusRamoEnum {
    Ativo = '1',
    Inativo = '0'
}